import { render, staticRenderFns } from "./affiliateUserAuditManage.vue?vue&type=template&id=45ff8236&scoped=true"
import script from "./affiliateUserAuditManage.vue?vue&type=script&lang=js"
export * from "./affiliateUserAuditManage.vue?vue&type=script&lang=js"
import style0 from "./affiliateUserAuditManage.vue?vue&type=style&index=0&id=45ff8236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff8236",
  null
  
)

export default component.exports